
import { writable } from 'svelte/store';

export function initialize_selector() {

    let selection_active = false;
    const active_item = writable(null);
    const selected_item = writable(null);

    function hover(item) {
        if (!selection_active) {
            active_item.set(item);
        }
    }

    function select(item) {
        if (item) {
            selection_active = true;
            selected_item.set(item);
            active_item.set(item);
        } else {
            selection_active = false;
            selected_item.set(null);
            active_item.set(null);
        }
    }

    function reset(e, target) {
        if (!e.target.matches(target)) {
            select(null);
        }
    }
    
    return {
        hover, select, selected_item, active_item, reset
    }
}